<template>
    <div id="popup" class="animated fadeIn">
        <div class="bg">
            <div class="content">
                <div class="close" @click="$emit('closePopup',false)">✘</div>
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "popup",
    components: {},
    props: {
        pophtml: {
            type: String
        },
        btn: {
            type: Object,
            default: function() {
                return {
                    Url: "",
                    Name: "確認"
                };
            }
        }
    },
    data() {
        return {};
    },
    methods: {},
    computed: {},
    created() {},
    mounted() {},
    watch: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#popup {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 100vh;
    z-index: 105;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #666;
}
#popup .bg {
    background-color: #fff;
    width: 950px;
    padding: 20px;
    /* min-height: 250px; */
    text-align: center;
    position: relative;
}
#popup .bg .content .close {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 18px;
    height: 18px;
    cursor: pointer;
}
#popup .bg .content >>> span {
    color: #ee8b59;
    font-size: 1.2rem;
    padding: 30px 0;
    display: inline-block;
}
#popup .bg .content >>> p {
    line-height: 1.5;
    letter-spacing: 2px;
    padding: 10px 0;
}
#popup .bg .content >>> p span {
    color: #ee8b59;
    padding: 0;
    font-size: 1rem;
}

/* #popup .bg .btn_box {
  width: 165px;
  margin: auto;
  padding: 15px 0;
} */
@media screen and (max-width: 767px) {
    #popup .bg {
        width: 95%;
    }
}
</style>




// WEBPACK FOOTER //
// src/components/popup/index.vue